import { APIClient } from "api/api_helper";
import { GetUserData, CurrentUser } from "common/service/CommonService";
import { TRANSFER_API } from "api/url_helper";

const api = new APIClient();

export const transferApiService = {

  // SELECT ALL
  getSelectAllData: (params: any) => {
    return api.create(TRANSFER_API.TRANSFER_API + "SelectAll", params);
  },

  // SELECT BY ID
  getSelectData: (id: number | string) => {
    return api.create(TRANSFER_API.TRANSFER_API + "Select", { transferid: id });
  },

  verifyPin: (payload: { verifypin: string, transferid: number, studyid: number, verifiedby: number }) => {
    return api.create(TRANSFER_API.TRANSFER_API + "Verify", payload);
  },

  // INSERT
  insertData: (payload_data: any) => {
    const formdata=new FormData()
    const user = GetUserData() as CurrentUser;

    // 1. Append form fields
    Object.entries(payload_data).forEach(([key, value]) => {
      // Skip attachments (handled below) and empty/null values if necessary
      if (key === "attachments" || value === null || value === undefined) return;

      // Regular fields
      formdata.append(key, String(value));
    });

    // 2. Append files
    if (Array.isArray(payload_data.attachments)) {
      payload_data.attachments.forEach((file: File) => {
        formdata.append(`files[${(file as any).attachmenttype}]`, file);
      });
    }

    // 3. System fields
    formdata.append("createdby", String(user?.userid ?? ""));

    return api.create(TRANSFER_API.TRANSFER_API + "Insert", formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // UPDATE
  updateData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const formdata = new FormData();

    // 1. Append form fields
    Object.entries(payload_data).forEach(([key, value]) => {
      if (key === "attachmenttypes" || value === null || value === undefined) return;

      if (key === "deletedAttachmentIds" && Array.isArray(value)) {
        formdata.append(key, JSON.stringify(value));
        return;
      }

      formdata.append(key, String(value));
    });

    // 2. Append files
    if (Array.isArray(payload_data.attachments)) {
      payload_data.attachments.forEach((file: File) => {
        formdata.append(`files[${(file as any).attachmenttype}]`, file);
      });
    }

    // 3. System fields
    formdata.append("updatedby", String(user?.userid ?? ""));

    return api.create(TRANSFER_API.TRANSFER_API + "Update", formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // DELETE
  deleteData: (payload_data: { transferid: number | null; updatereason: string; }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      transferid: payload_data.transferid,
      updatereason: payload_data.updatereason,
      updatedby: user.userid,
    };
    return api.create(TRANSFER_API.TRANSFER_API + "Delete", payload);
  },
};
